/**
 * FinancialsCard Component
 *
 * Form card for editing valuation, ownership, and networth inclusion.
 *
 * Props:
 *   - item: The asset/liability object
 *   - isLiability: Boolean indicating if this is a liability
 *   - validationError: Error element to display for valuation field
 *   - onFieldChange: Function(field, value) to update a field
 */

import CurrencyInput from 'react-currency-input-field';
import { ReceiptIcon, SealPercentIcon, ProhibitIcon } from '@phosphor-icons/react';
import { CURRENCY_LONG, LOCALE } from 'utilities/global.variables';

const FinancialsCard = ({ item, isAsset, isLiability, validationError, onFieldChange }) => {


  var onValueChangeHandler;
  var prefix
  var placeholder

  if (isAsset) {
    onValueChangeHandler = (value) => { onFieldChange("valuation", value); };
    prefix = '£'
    placeholder = "£100,000"
  }

  if (isLiability) {
    onValueChangeHandler = (value) => { onFieldChange("valuation", value); };
    prefix = '£'
    placeholder = "£50,000"
  }


  return (
    <div className="card">
      <div className="flex row medium-gap center space">
        <p className="regular">Financials</p> {validationError}
      </div>

      <div className="form-group margin-top-medium">
        <div className="form-item">
          <div className="flex row medium-gap center">
            
            {/* <ReceiptIcon size={14} /> */}
            <label htmlFor="valuation">Value</label>
          </div>
          <CurrencyInput id="valuation" value={isNaN(item.valuation) ? "" : Math.abs(item.valuation)} intlConfig={{ locale: LOCALE, currency: CURRENCY_LONG.currency }} className="number medium" allowDecimals={false} allowNegativeValue={false} prefix={prefix} placeholder={placeholder} onValueChange={onValueChangeHandler} />
        </div>
        <div className="form-item">
          <div className="flex row medium-gap center">
      
            {/* <SealPercentIcon size={14} /> */}
            <label htmlFor="ownership">Ownership</label>
          </div>

          <CurrencyInput
            id="ownership"
            suffix="%"
            className="number medium percent"
            value={isNaN(item.ownership) ? "" : item.ownership}
            placeholder="What percentage do you own?"
            allowNegativeValue={false}
            allowDecimals={false}
            onValueChange={(value) => {
              onFieldChange("ownership", Math.min(100, Math.max(0, value)));
            }}
          />
        </div>
        <div className="form-item">
          <div className="flex row medium-gap center">
  
            {/* <ProhibitIcon size={14} /> */}
            <label htmlFor="include_networth">Exclude from networth</label>
          </div>

          <div className="">
            <input type="checkbox" id="include_networth" className="input-toggle" checked={!item.include_networth} onChange={(e) => onFieldChange("include_networth", !e.target.checked)} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialsCard;
